import { render, staticRenderFns } from "./ProfitAndLossCostsDataTableReadOnly.vue?vue&type=template&id=06e65cc4"
import script from "./ProfitAndLossCostsDataTableReadOnly.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossCostsDataTableReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ProfitAndLossCostsDataTableReadOnly.vue?vue&type=style&index=0&id=06e65cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports